import React from 'react'
import { Button, Grid, Space, AutoCenter, Input, Form } from 'antd-mobile'
import { Link } from 'react-router-dom'
import LoginHeader from '../../components/LoginHeader'
import ServiceTerminationNotice from '../../components/ServiceTerminationNotice'
import { EyeInvisibleOutline } from 'antd-mobile-icons'
import { useTranslation } from 'react-i18next'
import { useRecoilState } from 'recoil'
import { LANGUAGE, languageCurrentRecoil } from '../../recoils/language'
import { Select } from 'antd'

const Register: React.FC = () => {
  const { t } = useTranslation()
  const [languageCurrent, setLanguageCurrent] = useRecoilState(languageCurrentRecoil)

  return (
    <div
      className="container"
      style={{ backgroundColor: 'var(--main-background-color)', padding: '120px 20px', position: 'relative' }}
    >
      <ServiceTerminationNotice fixed />
      <Select
        labelInValue
        style={{ position: 'absolute', top: '90px', right: '30px' }}
        defaultValue={{
          value: languageCurrent,
          label: languageCurrent === LANGUAGE.JAPANESE.VALUE ? LANGUAGE.JAPANESE.NAME : LANGUAGE.ENGLISH.NAME,
        }}
        onChange={({ value }) => setLanguageCurrent(value)}
        options={[
          {
            value: LANGUAGE.JAPANESE.VALUE,
            label: LANGUAGE.JAPANESE.NAME,
          },
          {
            value: LANGUAGE.ENGLISH.VALUE,
            label: LANGUAGE.ENGLISH.NAME,
          },
        ]}
      />
      <Grid columns={1} gap={15}>
        <LoginHeader />
        <Form
          style={{
            borderRadius: 'var(--wrapper-border-radius)',
            padding: ' 10px 10px 15px',
            backgroundColor: '#ffffff',
            '--border-top': 'none',
            '--border-bottom': 'none',
            marginTop: '16px',
          }}
        >
          <Form.Header>
            <AutoCenter style={{ fontSize: '20px', fontWeight: 400, color: '#000000' }}>
              {t('register.title')}
            </AutoCenter>
          </Form.Header>
          <p className="register-closed-notice">現在、新規登録は受け付けておりません。</p>
          <Form.Item label={t('register.email')}>
            <Input disabled type="email" placeholder="example@sugnee.jp" />
          </Form.Item>
          <Form.Item label={t('register.password')}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Input disabled placeholder="********" type="password" autoComplete="off" />
              <div style={{ cursor: 'not-allowed', opacity: 0.4 }}>
                <EyeInvisibleOutline />
              </div>
            </div>
          </Form.Item>
          <Form.Item>
            <Button
              color="primary"
              style={{ width: '100%', height: '40px', borderRadius: 'var(--adm-button-border-radius)' }}
              disabled
            >
              {t('register.button.sign-up')}
            </Button>
          </Form.Item>
          <Link to="/login">
            <Space block justify="end" style={{ fontWeight: 400, fontSize: '16px' }}>
              <Button color="primary" fill="none" style={{ textDecoration: 'underline' }}>
                {t('register.button.login')}
              </Button>
            </Space>
          </Link>
        </Form>
      </Grid>
    </div>
  )
}

export default Register
